import script from "./BalVerticalSteps.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalVerticalSteps.vue?vue&type=script&lang=ts&setup=true"

import "./BalVerticalSteps.vue?vue&type=style&index=0&id=46fa5d7c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46fa5d7c"]])

export default __exports__